import * as React from 'react';
import Text from '../text';
import Separator from '../atoms/separator';
import { Color } from '../../styles/colors';
import AppBadges from './components/app-badges';
import Logos from './components/logos';
import LegalLinks from './components/legal-links';
import SectionLinks from './components/section-links';
import ExitReverie from './components/exit-reverie';
import AccessibilityLink from './components/accessibility-link';
import { SECTIONS } from './data/bpp';
import { LEGAL_LINKS } from './data/legal-links';
import { LOGOS } from './data/logos';
type Props = {
  exitPath?: string;
};

const FooterBlinkPharmacyPlus = ({ exitPath }: Props) => {
  return (
    <section
      className={`d-print-none py-sm-24 ${exitPath ? 'pt-lg-36 pb-lg-60' : 'py-lg-60'}`}
      style={{
        color: Color.tertiary100,
      }}
    >
      <div className="container" data-user1st-id="footer-bpp">
        {exitPath && (
          <React.Fragment>
            <ExitReverie to={exitPath} />
            <Separator className="my-sm-24 my-lg-36" />
          </React.Fragment>
        )}

        <div className="row">
          <SectionLinks items={SECTIONS} />

          <div className="col-md-6 col-lg-8 d-sm-none d-lg-flex flex-sm-column">
            <Text className="mb-sm-16" type="title4-blinkui">
              Try the app now
            </Text>
            <div className="d-sm-flex align-items-sm-center mb-sm-n4" data-user1st-id="footer-social-app">
              <AppBadges height={40} />
            </div>
          </div>
        </div>

        <Separator className="mt-sm-0 mb-sm-24 mb-lg-36" />

        <div className="row d-lg-none">
          <div className="col-sm-12 d-sm-flex flex-sm-column">
            <Text className="mb-sm-16" type="title4-blinkui">
              Try the app now
            </Text>
            <div className="d-sm-flex align-items-sm-center mb-sm-n4" data-user1st-id="footer-social-app">
              <AppBadges height={48} />
            </div>
          </div>
        </div>

        <Separator className="d-lg-none my-sm-24 my-lg-36" />

        <div className="row">
          <LegalLinks className="col-sm-12 col-lg-6" items={LEGAL_LINKS} />
          <Logos className="col-sm-12 col-lg-6 justify-content-lg-end mt-sm-24 mt-lg-0" items={LOGOS} />
          <div className="col-sm-12">
            <AccessibilityLink />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterBlinkPharmacyPlus;
